var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProfileReadMyStory',{attrs:{"stories":_vm.user.faq || []},on:{"update":_vm.onUpdate,"dirty":function($event){_vm.hasUserChanges = true}}}),_c('StepperButtons',{attrs:{"isSaving":_vm.isSaving},on:{"continue":_vm.clickContinue,"skip":function($event){return _vm.$emit('complete')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }